var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('span',[_vm._v("404")]),_c('div',{staticClass:"btn-go-home"},[_c('van-button',{attrs:{"size":"small","plain":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go To Home")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }